/* Profile avatar component */

import {CSSProperties, MouseEventHandler} from 'react';

import anim from 'Style/anim';

import withMouseOver from '../higher_order_components/with_mouse_over';

import Identicon from './identicon';
import UploadcareImage from './uploadcare_image';

const style = {
  avatarStyle: {
    ...anim.std,
  },
};

type Props = {
  profile: {
    hash: string;
    name: string;
    image: string;
  };
  width: number;
  height: number;
  extraStyle?: CSSProperties;
  title?: string;
  onClick?: MouseEventHandler<HTMLImageElement>;
  generateIdenticon?: boolean;
  hover: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

const RawProfileAvatar = ({
  profile,
  width,
  height,
  extraStyle = {},
  title = '',
  onClick,
  generateIdenticon = true,
  hover,
  onMouseEnter,
  onMouseLeave,
}: Props) => {
  if (profile.image) {
    const imgTransfos = [
      {
        name: 'preview',
        width,
        height,
      },
    ];
    return (
      <div
        style={style.avatarStyle}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <UploadcareImage
          uuid={profile.image}
          transformations={imgTransfos}
          title={title}
          onClick={onClick}
          alt="profile avatar"
          style={extraStyle}
        />
      </div>
    );
  }
  if (generateIdenticon) {
    // First name initial
    return (
      <div
        style={style.avatarStyle}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <Identicon
          name={profile.name}
          hash={profile.hash}
          width={width}
          height={height}
          title={title}
          onClick={onClick}
          hover={hover}
          extraStyle={extraStyle}
        />
      </div>
    );
  } else {
    return <div />;
  }
};

const ProfileAvatar = withMouseOver(RawProfileAvatar);

export default ProfileAvatar;
